import React, { useEffect, useState } from 'react';

export default function CombatIntro({ enemyName, onComplete }) {
  const [phase, setPhase] = useState(0);

  useEffect(() => {
    setTimeout(() => setPhase(1), 100);
    setTimeout(() => setPhase(2), 1500);
    setTimeout(() => setPhase(3), 3000);
    setTimeout(() => { setPhase(4); onComplete(); }, 3800);
  }, []);

  return (
    <div className={`combat-intro phase-${phase}`}>
      <div className="intro-vignette"></div>
      <div className="intro-lines">
        <div className="intro-line line-top"></div>
        <div className="intro-line line-bot"></div>
      </div>
      <div className="intro-content">
        <div className="intro-label">⚔️ ENCOUNTER</div>
        <div className="intro-enemy">{enemyName}</div>
        <div className="intro-subtitle">Prepare for battle</div>
      </div>
      <div className="intro-particles">
        {[...Array(20)].map((_, i) => (
          <div key={i} className="intro-spark" style={{
            left: `${Math.random() * 100}%`,
            top: `${Math.random() * 100}%`,
            animationDelay: `${Math.random() * 2}s`,
            animationDuration: `${1 + Math.random() * 2}s`,
          }}></div>
        ))}
      </div>
      <div className="intro-flash"></div>
    </div>
  );
}
